import { useState, useEffect, useContext, useMemo, useRef } from "react";
import {
  Flex,
  Text,
  Box,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Heading,
  Grid,
  Button,
  Tooltip,
  Checkbox,
  useBreakpointValue,
  Center,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import {
  FaBackward,
  FaEdit,
  FaFileExcel,
  FaFilePdf,
  FaFileUpload,
  FaHistory,
  FaPlus,
} from "react-icons/fa";
import Pagination from "components/common/Pagination/Pagination";
import { AppContext } from "AppProvider/AppContext";
import debounce from "lodash/debounce";
import { Paginationlimit } from "components/common/functions/variable";
import ViewerModal from "App/BsesPoc/components/common/ViewerModal/ViewerModal";
import { CopyIcon, SearchIcon } from "@chakra-ui/icons";
import MultiDropdown from "components/common/multiDropdown/MultiDropdown";
import Datepicker from "./common/DatePicker";
import AddComentModal from "./common/AddComentModal/AddComentModal";
import { canShowDocuments } from "./common/function";
import React from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { AiFillEye } from "react-icons/ai";
import CustomDateRangePicker from "./common/CustomDateRangePicker/CustomDateRangePicker";
import { HiOutlineDocumentAdd, HiOutlineRefresh } from "react-icons/hi";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";
import FileViewerModal from "./common/ViewerModal/FileViewerModel";
import TableViewerModel from "./common/TableViewer/TableViewer";
import CurbayViewerModel from "./common/ViewerModal/CurbayViewerModal/CurbayViewerModel";
import {
  MdArrowUpward,
  MdArrowDownward,
  MdEmail,
  MdAssignmentInd,
} from "react-icons/md";
import TableLoader from "components/common/TableLoader/TableLoader";
import WordDocumentViewer from "./common/WordDocumentViewer/WordDocumentViewer";
import ApprovalHistoryModal from "./common/ApprovalHistoryModal/ApprovalHisoryModal";
import UploadDocumentModal from "./common/UploadDocumentModal/UploadDocumentModal";
import {
  addOneDayToDate,
  DDMMYYYY_FORMAT,
  formatDateTime,
} from "utils/dateUtils/dateUtils";
import DynamicSchemaModel from "./common/ViewerModal/DynamicSchemaModel";
import exportToExcelsss, {
  transformData,
} from "./common/PRYViewer/component/utils/functions";
import MailModal from "./common/PRYViewer/component/MailModal";
import CurbayMedicineCustomModal from "./common/PRYViewer/component/CurbayMedicineCustomModal";
import FieldsModal from "./common/fields/FieldsModal";
import DeleteModal from "./common/Modals/DeleteModal";
import FilesModal from "./common/FilesModal/FilesModal";
import WithDrawalDocModal from "./common/Modals/WithDrawalDocModal";
import AddtionalDocumentModal from "./common/addionalDocumentModal/AddionalDocumentModal";
import DownloadExcelComponent from "./DownloadExcelComponent";
import AssignDocumentModal from "./Approvals/component/AssignDocumentModal";
import { Portal } from "@chakra-ui/react";
import { FiChevronLeft } from "react-icons/fi";
import { useSearchParams } from "react-router-dom";
import { routePath } from "config/pathConstant";

type Data = {
  _id: string;
  invoiceNo: string;
  dueDate: string;
  submittedOn: string;
  approvedOn: string;
  modifiedOn: string;
  comment?: string;
  status: string;
  file?: any;
  values?: any;
};

export default function SingleSchemaDocument({
  name,
  type,
  activePage,
  isDisabled,
  isManual,
  documentId,
}: {
  name: string;
  type: string;
  activePage: string;
  isDisabled: boolean;
  isManual: boolean;
  documentId: any;
}): JSX.Element {
  const { setActivePage } = useContext(AppContext)
  const [, setSearchParams] = useSearchParams();
  const [openDeleteModal, setOpenDeleteModal] = useState<any>({
    data: null,
    open: false,
  });
  const [withdrawalDoc, setWithdrawalDoc] = useState<any>({
    data: null,
    open: false,
    loading: false,
  });
  const [wordType, setWordType] = useState<any>("view");
  const [openTableModel, setOpenTableModel] = useState<any>({
    type: "file",
    open: false,
    file: null,
  });
  const [openFilesModal, setOpenFilesModel] = useState<any>({
    type: "files_verification",
    open: false,
    file: null,
    data: null,
  });
  const [openSchemaModel, setOpenSchemaModel] = useState({
    open: false,
    type: "schema",
    data: null,
    initialUpload: false,
    file: null,
  });
  const {
    workFlowData,
    setActiveWorkflow,
    activeWorkflow,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    resetDates,
    workflowProcess
  } = useContext(AppContext);

  const [commentModel, setCommentModel] = useState<any>({
    selectedStatus: "approved",
    open: false,
    comment: "",
    isMulti: false,
  });
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const { toastNotify } = useContext(AppContext);
  const [data, setData] = useState<Data[]>([]);
  const [search, setSearch] = useState("");
  const [selectedFile, setSelectedFile] = useState<any>({});
  const [values, setValues] = useState<any>({});
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState({
    isOpen: false,
    data: null,
    type: "isFile",
  });
  const [assignDocument, setAssignDocument] = useState({
    open: false,
    data: null,
  });
  const [initialLoad, setInitialLoad] = useState(true);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const [sortColumn, setSortColumn] = useState<keyof Data | null>(null);
  const [tagType, setTagType] = useState("");
  const [documentType, setDocumentType] = useState(null);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [level, setLevel] = useState<string | null>(null);
  const [comment, setComment] = useState<string>("");
  const { accountDetails } = useContext(AppContext);
  const [transformedOptions, setTransformedOptions] = useState([]);
  const [tableObject, setTableObject] = useState<any>([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [sortDirection, setSortDirection] = useState<any>({});
  const [approvalData, setApprovalData] = useState([]);
  const [documentID, setDocumentID] = useState<any>(null);
  const [transformedData, setTransformedData] = useState<any[]>([]);
  const [fileData, setFileData] = useState<any>(null);
  const [sendMail, setSendMail] = useState<any>(false);
  const [fieldName, setFieldName] = useState<string[]>([]);
  const [finalResults, setFinalResults] = useState<any>([]);
  const fileInputRef = useRef<any>(null);
  const isBreakpoint = useBreakpointValue({ base: true, lg: false });
  const [isMailOpen, setIsMailOpen] = useState<any>({
    open: false,
    data: null,
  });
  const [searchFilters, setSearchFilters] = useState<any[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>({});
  const [addtionalDocuments, setAddtionalDocuments] = useState({
    open: false,
    data: [],
  });

  const handleCloseModal = () => {
    setSelectedFile({});
    setValues({});
    setIsOpen({ isOpen: false, data: null, type: "isFile" });
    setSelectedRows([]);
    setCommentModel({
      selectedStatus: "approved",
      open: false,
      comment: "",
      isMulti: false,
    });
    setWordType("view");
  };

  const getComment = (data: any) => {
    if (data && Array.isArray(data)) {
      if (data.length) {
        let ddt: any = data.filter(
          (item: any) => item.level === accountDetails.level
        );
        if (ddt.length) {
          return ddt[ddt.length - 1].comment;
        } else {
          return data[data.length - 1].comment;
        }
      }
      return "-";
    } else {
      return "-";
    }
  };

  const handleOpenMail = (values: any) => {
    let transformed: any = [];
    if (Array.isArray(values)) {
      transformed = values[values?.length - 1]?.values;
    } else {
      if (Array.isArray(values?.values?.results)) {
        if (Array.isArray(values?.values?.results)) {
          let data = transformData(values?.values?.results);
          const groupedData = data.reduce(
            (acc: any[], { fieldName, rows, pageIndex }: any) => {
              if (!acc[pageIndex]) {
                acc[pageIndex] = { pageIndex, fields: {} };
              }
              acc[pageIndex].fields[fieldName] = rows.map((row: any) => {
                const rowData: any = {};
                for (const key in row) {
                  if (key !== "id") {
                    rowData[key] = row[key];
                  }
                }
                return rowData;
              });
              return acc;
            },
            []
          );
          transformed = groupedData;
          setTransformedData(groupedData);
        }
      }
      transformed = values;
    }
    setTransformedData(transformed);
    setIsMailOpen({ open: true });
  };

  const handleCloseMail = () => {
    setIsMailOpen({ open: false, data: null });
  };

  const getDocumentType = (data: any) => {
    if (
      data.length &&
      name === "Pending Approval" &&
      accountDetails.level !== "level-1"
    ) {
      if (data.length) {
        let level: any = null;
        if (accountDetails.level === "level-2") {
          level = "level-1";
        }
        if (accountDetails.level === "level-3") {
          level = "level-2";
        }
        const dd: any = data.filter((item: any) => item.level === level);
        if (dd.length) {
          return dd[0].status;
        }
      }
      return null;
    } else {
      return null;
    }
  };

  const handleOpenModal = ({
    file,
    value,
    id,
    level,
    approvalData,
    documentId,
    tagType,
    item,
    type,
    modalType,
  }: {
    file: any;
    value: any;
    id: any;
    level: any;
    approvalData: any;
    documentId: any;
    tagType: string;
    item: any;
    type: string;
    modalType: string;
  }) => {
    if (workFlowData?.fileViewer?.approvalModalOption === "schema") {
      setValues(value);
      setSelectedId(id);
      setLevel(level);
      setComment(getComment(approvalData));
      setDocumentType(getDocumentType(approvalData));
      setSelectedRows((prevVal) => [...prevVal, item]);
      if (type !== "pdfApproval") {
        setOpenSchemaModel({
          open: true,
          data: item,
          type: "schema",
          initialUpload: false,
          file: null,
        });
      }
      setIsOpen({ isOpen: true, data: item, type: type });
      setSelectedFile(file);
      setApprovalData(approvalData);
      setDocumentID(documentId);
    } else if (file && !workFlowData?.fileViewer?.approvalModalOption.isWord) {
      setSelectedFile(file);
      setValues(value);
      setSelectedId(id);
      setLevel(level);
      setComment(getComment(approvalData));
      setApprovalData(approvalData);
      setDocumentType(getDocumentType(approvalData));
      setTagType(tagType);
      setSelectedRows((prevVal) => [...prevVal, item]);
      setIsOpen({ isOpen: true, data: item, type: type });
      setDocumentID(documentId);
    } else {
      if (
        !file &&
        (workFlowData?.fileViewer.approvalModalOption === "isWord" ||
          workFlowData?.fileViewer.approvalModalOption === "files_verification")
      ) {
        setSelectedFile(file);
        setValues(value);
        setSelectedId(id);
        setLevel(level);
        setComment(getComment(approvalData));
        setDocumentType(getDocumentType(approvalData));
        setTagType(tagType);
        setSelectedRows((prevVal) => [...prevVal, item]);
        if (workFlowData?.fileViewer.approvalModalOption === "isWord") {
          setIsOpen({ isOpen: true, data: item, type: type });
        }
        if (
          workFlowData?.fileViewer.approvalModalOption === "files_verification"
        ) {
          setOpenFilesModel({
            open: true,
            data: item,
            type: workFlowData?.fileViewer.approvalModalOption,
          });
        }
        setApprovalData(approvalData);
        setDocumentID(documentId);
      } else {
        toastNotify({
          title: "No file",
          message: "Something went wrong",
          type: "error",
        });
      }
    }
  };

  const downloadExcel = async (values: any, action: any) => {
    let transformed: any = [];
    let downloadValues = [];
    if (Array.isArray(values)) {
      transformed = values[values?.length - 1]?.values;
    } else {
      if (Array.isArray(values?.values?.results)) {
        let data = transformData(values?.values?.results);
        const groupedData = data.reduce(
          (acc: any[], { fieldName, rows, pageIndex }: any) => {
            if (!acc[pageIndex]) {
              acc[pageIndex] = { pageIndex, fields: {} };
            }
            acc[pageIndex].fields[fieldName] = rows.map((row: any) => {
              const rowData: any = {};
              for (const key in row) {
                if (key !== "id") {
                  rowData[key] = row[key];
                }
              }
              return rowData;
            });
            return acc;
          },
          []
        );
        transformed = groupedData;
        setTransformedData(groupedData);
      }
      downloadValues = values;
    }
    setTransformedData(transformed);
    if (workFlowData?.fileViewer?.approvalModalOption === "mdm") {
      exportToExcelsss(transformed, true);
    }
  };

  const [isUploadOpen, setIsUploadOpen] = useState<{ open: boolean; id: any }>({
    open: false,
    id: null,
  });
  const [modalType, setModalType] = useState<string>("");

  const handleOpenUploadModal = (type: string, id?: any) => {
    setOpenSchemaModel({
      open: true,
      data: null,
      type: "schema",
      initialUpload: true,
      file: null,
    });
    return;
    if (id !== null) {
      setIsUploadOpen({ open: true, id: id });
    } else {
      setIsUploadOpen({ open: true, id: null });
    }
    setModalType(type);
  };

  const handleCloseUploadModal = () => {
    setIsUploadOpen({ open: false, id: null });
  };

  const actionButton =
    tableObject?.action?.view ||
    tableObject?.action?.edit ||
    tableObject?.action?.delete;

  const handleGet = async (
    currentP?: number,
    valu?: any,
    reset?: any,
    columnSortByKey?: string,
    columnSortMode?: number
  ) => {
    try {
      let firstActiveItem: any = null;
      if (workFlowData && workFlowData?.table) {
        const activeItems = workFlowData.table.filter(
          (item: any) => item.isActive === true
        );
        firstActiveItem = activeItems.length > 0 ? activeItems[0] : {};
      }
      if (!loading) setLoading(true);
      let value = search;
      let status = type;
      let limit = firstActiveItem?.isPaginate?.isActive
        ? parseInt(firstActiveItem?.isPaginate?.paginationLimit)
        : Paginationlimit;
      let page = currentP ? currentP : currentPage;

      let query: any = {
        value,
        limit,
        status,
        page,
        level: accountDetails.level,
        _id: accountDetails.user,
        company: accountDetails.company?._id || accountDetails.company,
      };

      if (
        workFlowData?.searchFilter?.key &&
        workFlowData?.searchFilter?.isActive &&
        value?.trim()
      ) {
        query = { ...query, searchField: workFlowData?.searchFilter?.key };
      }

      // Using global startDate & endDate from context
      if (workFlowData.dateFilter?.rangeActive) {
        query = {
          ...query,
          dateFrom: startDate,
          dateTo: addOneDayToDate(endDate),
        };
      }

      if (reset) {
        resetDates(); // Reset global dates
      }

      if (columnSortByKey && columnSortMode) {
        query = {
          ...query,
          sort: columnSortMode,
          sortByKey: columnSortByKey,
        };
      } else {
        if (workFlowData?.sortBy && workFlowData?.sortBy?.length) {
          const sorts = workFlowData.sortBy.filter(
            (item: any) => item.isActive === true
          );
          if (sorts?.length) {
            query = {
              ...query,
              sort: sorts[0].mode,
              sortByKey: sorts[0].key,
            };
          }
        }
      }

      if (
        workFlowData.dateFilter?.filterKey &&
        workFlowData.dateFilter?.filterKey?.length
      ) {
        query = { ...query, dateFilterKey: workFlowData.dateFilter?.filterKey };
      }

      if (activeWorkflow !== accountDetails?.defaultWorkflow) {
        query = { ...query, activeWorkflow: activeWorkflow };
      }

      if (type === "manual") {
        query["manual"] = true;
      }

      const searchFilters: any = [];
      for (const key in selectedOptions) {
        if (selectedOptions[key].length > 0) {
          selectedOptions[key].forEach((item: any) => {
            const filterObject: any = {};
            filterObject[key] = item.value;
            searchFilters.push(filterObject);
          });
        } else {
          const filterObject: any = {};
          filterObject[key] = selectedOptions[key].value;
          searchFilters.push(filterObject);
        }
      }

      if (!reset) {
        if (searchFilters.length) {
          query = { ...query, searchFilters: searchFilters };
        }
      }

      if (documentId) {
        query = { ...query, value: documentId };
      }
      const response: any = await appRequest("document", "get", {
        ...query,
        workflowId: workFlowData?._id,
        processName: workFlowData?.processName,
        processType: workFlowData?.processType,
      });

      if (response) {
        if (Array.isArray(response?.data)) {
          setData(response?.data);
          setTotalPages(response?.totalPages);
        } else {
          setData([]);
        }
      } else {
        toastNotify({
          title: `Error getting the Data`,
          message: response.message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the Data`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteDocuments = async () => {
    try {
      setDeleteLoading(true);
      const response: any = await appRequest("document", "delete", {
        documentId: openDeleteModal?.data?.documentId,
      });
      if (response) {
        handleGet();
        toastNotify({
          title: `Document has been deleted`,
          message: response.message || "Something went wrong",
          type: "success",
        });
        setOpenDeleteModal({ data: null, open: false });
      } else {
        toastNotify({
          title: `Failed to delete document`,
          message: response.message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Failed to delete document`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
      setDeleteLoading(false);
    }
  };

  const withDrawalDocuments = async () => {
    try {
      setWithdrawalDoc({ ...withdrawalDoc, loading: true });
      const response: any = await appRequest("document", "withdrawal", {
        documentId: withdrawalDoc?.data?.documentId,
      });
      if (response) {
        handleGet();
        toastNotify({
          title: `Document has been WithDrawal`,
          message: response.message || "Something went wrong",
          type: "success",
        });
        setWithdrawalDoc({ data: null, open: false, loading: false });
      } else {
        toastNotify({
          title: `Failed to delete document`,
          message: response.message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error: any) {
      setWithdrawalDoc({ ...withdrawalDoc, loading: false });
      toastNotify({
        title: `Failed to delete document`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
    }
  };

  const handleSort = (column: keyof Data, direction: number) => {
    setSortDirection((prevState: any) => ({
      ...prevState,
      [column]: prevState[column] === "asc" ? "desc" : "asc",
    }));
    Object.keys(sortDirection).forEach((columnKey) => {
      if (columnKey !== column) {
        setSortDirection((prevState: any) => ({
          ...prevState,
          [columnKey]: undefined,
        }));
      }
    });
    handleGet(undefined, undefined, undefined, column, direction);
  };

  const sortedData = useMemo(() => {
    if (sortColumn) {
      const sortedArray = [...data].sort((a, b) => {
        const valueA = a[sortColumn] ?? "";
        const valueB = b[sortColumn] ?? "";
        if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
        if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
      return sortedArray;
    }
    return data;
  }, [data, sortColumn, sortOrder]);

  useEffect(() => {
    setLoading(true);
    if (initialLoad) {
      handleGet(currentPage);
      setInitialLoad(false);
    } else {
      const debounceSearch = debounce((value) => {
        handleGet(currentPage, value);
      }, 1000);
      debounceSearch(search);
      return () => {
        debounceSearch.cancel();
      };
    }
  }, [
    search,
    currentPage,
    activePage,
    workFlowData,
    activeWorkflow,
    startDate,
    endDate,
  ]);

  const getFile = async (file: any) => {
    try {
      if (file?._id) {
        const response: any = await appRequest("filesystem", "get", {
          id: file._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);
            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType })
            );
            return fileURL;
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    }
  };

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
  };

  const downloadPDF = async (file: any) => {
    const fileUrl = await getFile(file);
    if (fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.style.display = "none";
      link.download = file.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleSelectedBoxChange = (item: any) => {
    const isSelected = selectedRows.some(
      (selectedItem) => selectedItem._id === item._id
    );
    setSelectedRows((prevSelectedRows) =>
      isSelected
        ? prevSelectedRows.filter(
          (selectedItem) => selectedItem._id !== item._id
        )
        : [...prevSelectedRows, item]
    );
  };

  const getStatus = (data: any) => {
    if (Array.isArray(data) && data?.length) {
      return data[data.length - 1].status;
    } else {
      return "-";
    }
  };

  function getApprovalStatus(history: any) {
    let previousFileID: any = null;
    const isRejected = history.some((item: any, index: any) => {
      const fileIDChanged = index > 0 && item.fileId !== previousFileID;
      previousFileID = item.fileId;
      return item.status === "rejected" || fileIDChanged;
    });
    return isRejected ? "rejected" : "approved";
  }

  useEffect(() => {
    if (workFlowData && workFlowData.filters) {
      let filterWorkflowFilter = workFlowData?.filters.filter(
        (item: any) => item.isActive === true
      );
      const options = filterWorkflowFilter.map((filter: any) => ({
        label: filter.label,
        placeholder: filter.placeholder,
        isMultiSelect: filter.isMultiSelect,
        key: filter.key,
        options: filter.filters
          .filter((nestedFilter: any) => nestedFilter.isActive)
          .map((nestedFilter: any) => ({
            _id: nestedFilter.key,
            value: nestedFilter.key,
            label: nestedFilter.label,
          })),
      }));
      setTransformedOptions(options);
    }
  }, [workFlowData]);

  useEffect(() => {
    if (workFlowData && workFlowData?.table) {
      const activeItems = workFlowData.table.filter(
        (item: any) => item.isActive === true
      );
      const firstActiveItem = activeItems.length > 0 ? activeItems[0] : {};
      setTableObject(firstActiveItem);
    }
  }, [workFlowData?.table]);

  const generateHeaders = () => {
    return (
      <>
        {tableObject?.columnName?.map((column: any, index: any) => {
          const sortingIcon =
            sortDirection[column.key] === "asc" ? (
              <MdArrowUpward />
            ) : (
              <MdArrowDownward />
            );
          const isHovered = hoveredIndex === index;
          if (!column.isActive) return null;
          return (
            <Th
              key={index}
              cursor={column.sortActive ? "pointer" : undefined}
              onClick={() => {
                if (column.sortActive) {
                  const direction =
                    sortDirection[column.key] === "asc" ? -1 : 1;
                  handleSort(column.key, direction);
                }
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              textAlign={column.labelCenter === true ? "center" : "left"}
            >
              <Flex alignItems="center" gap={3}>
                <span
                  style={{
                    whiteSpace:
                      column.labelNoWrap === true ? "nowrap" : "unset",
                    textTransform: tableObject?.columnNameUpperCase
                      ? undefined
                      : "none",
                  }}
                >
                  {column.label?.split("_")?.join(" ")}
                </span>{" "}
                {column.sortActive && (
                  <Text
                    color="white"
                    fontSize=".7rem"
                    style={{ visibility: isHovered ? "visible" : "hidden" }}
                    wordBreak="normal"
                  >
                    {sortingIcon}
                  </Text>
                )}
              </Flex>
            </Th>
          );
        })}
        {actionButton && (
          <Th>
            <Text></Text>
          </Th>
        )}
        {workFlowData?.fileViewer?.showApprHistory && (
          <Th textAlign="center">
            <Text>Approval History</Text>
          </Th>
        )}
        {canShowDocuments(workFlowData, accountDetails) && <Th></Th>}
      </>
    );
  };

  const showComment = (item: any) => {
    if (!Array.isArray(item?.approval) || !item.approval.length) {
      return <Text>-</Text>;
    }

    // Latest comment first
    const comments = item.approval
      .slice()
      .reverse()
      .map((st: any, index: number) => {
        let username = st?.user?.username?.split("@")[0];

        if (username) {
          username = username
            .split(".")
            .map((part: string) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(" ");
        } else {
          username = st?.designation || "Unknown";
        }

        let level = "";
        if (st.level === "admin") {
          level = "Admin";
        } else if (st.user?.level?.includes("level-")) {
          level = `L-${st.user.level.split("-")[1]}`;
        }

        return (
          <Box
            key={index}
            py={2}
            borderBottom="1px solid"
            borderColor="gray.100"
          >
            {st.comment && (
              <Text fontSize="sm" lineHeight="1.4">
                <Text as="span" fontWeight="semibold" color="blue.600">
                  {level} · {username}
                </Text>
                {": "}
                {st.comment}
              </Text>
            )}
          </Box>
        );
      });

    const latestComment =
      item.approval[item.approval.length - 1]?.comment || "-";

    return (
      <Popover
        placement="top-start"
        trigger="hover"
        openDelay={200}
        closeDelay={100}
        isLazy
      >
        <PopoverTrigger>
          <Text
            isTruncated
            maxW="8rem"
            cursor="pointer"
            fontSize="sm"
            color="gray.700"
            _hover={{ color: "blue.600", textDecoration: "underline" }}
          >
            {latestComment}
          </Text>
        </PopoverTrigger>

        {/* 🔥 REQUIRED FIX FOR TABLE */}
        <Portal>
          <PopoverContent maxW="22rem" zIndex={9999} boxShadow="lg">
            <PopoverArrow />
            <PopoverBody maxH="220px" overflowY="auto" px={3} py={2}>
              {comments.length ? comments : <Text>No Comment</Text>}
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    );
  };

  const getTextValue = (item: any, key: any) => {
    if (!item || typeof item !== "object") {
      return "";
    }
    const value = item.originalValues?.[key] || item[key];
    if (typeof value === "string") {
      return value;
    }
    return value !== undefined ? JSON.stringify(value) : "";
  };

  const generateRows = (item: any) => {
    return (
      <React.Fragment key={item._id}>
        {tableObject?.columnName?.map((column: any, columnIndex: any) => {
          if (!column.isActive) return null;
          let content = null;
          if (column.key === "comments") {
            content = <Td key={columnIndex}>{showComment(item)}</Td>;
          } else if (
            column.key === "created_At" ||
            column.key === "updated_At"
          ) {
            content = (
              <Td
                key={columnIndex}
                whiteSpace={column.rowNoWrap === true ? "nowrap" : "unset"}
              >
                {formatDateTime(item[column.key], DDMMYYYY_FORMAT, true)}
              </Td>
            );
          } else if (column.isFile) {
            content = (
              <Td
                key={columnIndex}
                color="blue.400"
                textDecoration="underline"
                fontWeight="500"
                onClick={(e: any) => {
                  e.stopPropagation();
                  if (item[column.key]?.length) {
                    if (column.fileView) {
                      setOpenTableModel({
                        type: "file",
                        open: true,
                        file: item[column.key],
                      });
                    } else {
                      toastNotify({
                        title: "Access Error",
                        message: "Sorry, there was an issue accessing the file",
                        type: "error",
                      });
                    }
                  }
                }}
              >
                {Array.isArray(item[column.key]) ? (
                  item[column.key]?.length ? (
                    <Tooltip
                      hasArrow
                      textAlign="center"
                      label={item[column.key][0]?.filename}
                    >
                      {item[column.key][0]?.filename.substring(0, 10) + "..."}
                    </Tooltip>
                  ) : (
                    "--"
                  )
                ) : (
                  JSON.stringify(item[column.key])
                )}
              </Td>
            );
          } else {
            const rawValue = item?.originalValues?.[column.key] ?? "";

            const tooltipValue =
              column.tooltipLabel ??
              (typeof rawValue === "string"
                ? rawValue
                : rawValue !== ""
                  ? JSON.stringify(rawValue)
                  : "");

            const displayValue = getTextValue(item, column.key) ?? "";

            content = (
              <Td key={columnIndex} isNumeric={column.rowType === "amount"}>
                <Flex align="center" gap={2}>
                  {column.truncatedActive ? (
                    <Tooltip hasArrow label={item[column.key] || "—"}>
                      <Text
                        isTruncated
                        w="7rem"
                        textAlign={
                          column.rowType === "number"
                            ? "center"
                            : column.rowType === "amount"
                              ? "right"
                              : "left"
                        }
                      >
                        {displayValue || "—"}
                      </Text>
                    </Tooltip>
                  ) : (
                    <Text
                      textAlign={
                        column.rowType === "number"
                          ? "center"
                          : column.rowType === "amount"
                            ? "right"
                            : "left"
                      }
                      whiteSpace={
                        column.rowNoWrap === true ? "nowrap" : "unset"
                      }
                    >
                      {displayValue || "—"}
                    </Text>
                  )}

                  {[
                    "Invoice_Number",
                    "postingMessage",
                    "sapDocumentNumber",
                    "documentId",
                  ].includes(column.key) &&
                    Boolean(displayValue) && (
                      <Tooltip label="Copy" hasArrow>
                        <Box
                          cursor="pointer"
                          onClick={(e) => {
                            e.stopPropagation();

                            try {
                              navigator.clipboard?.writeText(displayValue);
                              toastNotify({
                                title: "Copied",
                                message: "Text copied to clipboard",
                                type: "success",
                              });
                            } catch (err) {
                              toastNotify({
                                title: "Failed",
                                message: "Unable to copy text",
                                type: "error",
                              });
                            }
                          }}
                        >
                          <CopyIcon color="gray.500" />
                        </Box>
                      </Tooltip>
                    )}
                </Flex>
              </Td>
            );

            // content = (
            //   <Td key={columnIndex} isNumeric={column.rowType === "amount"}>
            //     <Flex>
            //     {column.truncatedActive ? (
            //       <Tooltip
            //         hasArrow
            //         label={
            //           column.tooltipLabel
            //             ? column.tooltipLabel
            //             : typeof item.originalValues[column.key] === "string"
            //             ? item.originalValues[column.key]
            //             : JSON.stringify(item.originalValues[column.key])
            //         }
            //       >
            //         <Text
            //           isTruncated
            //           w="7rem"
            //           textAlign={
            //             column.rowType === "number"
            //               ? "center"
            //               : column.rowType === "amount"
            //               ? "right"
            //               : "left"
            //           }
            //         >
            //           {getTextValue(item, column.key)}
            //         </Text>
            //       </Tooltip>
            //     ) : (
            //       <Text
            //         textAlign={
            //           column.rowType === "number"
            //             ? "center"
            //             : column.rowType === "amount"
            //             ? "right"
            //             : "left"
            //         }
            //         whiteSpace={column.rowNoWrap === true ? "nowrap" : "unset"}
            //       >
            //         {getTextValue(item, column.key)}
            //       </Text>
            //     )}
            //     {['Invoice_Number','postingMessage','sapDocumentNumber'].includes(column.key) && <Tooltip label="Copy" hasArrow arrowSize={8}>
            //       <Box
            //         cursor="pointer"
            //         onClick={(e) => {
            //           e.stopPropagation();
            //           navigator.clipboard.writeText(
            //             getTextValue(item, column.key)
            //           );
            //           toastNotify({
            //             title: "Copied",
            //             message: "Text copied to clipboard",
            //             type: "success",
            //           });
            //         }}
            //       >
            //         <CopyIcon color="gray.500" />
            //       </Box>
            //     </Tooltip>}
            //     </Flex>
            //   </Td>
            // );
          }
          return content;
        })}
        {actionButton && (
          <Td>
            <Flex alignItems="center" justifyContent="start">
              {tableObject?.action?.view && (
                <Tooltip label="View" hasArrow arrowSize={15}>
                  <Flex
                    alignItems="center"
                    cursor="pointer"
                    color="green.500"
                    _hover={{ color: "green.600" }}
                  >
                    <Box mr=".5rem" fontSize="1.4rem">
                      <AiFillEye />
                    </Box>
                  </Flex>
                </Tooltip>
              )}
              {tableObject?.action?.edit && (
                <Tooltip label="Edit" hasArrow arrowSize={15}>
                  <Flex
                    alignItems="center"
                    cursor="pointer"
                    mx="1rem"
                    color="green.500"
                    _hover={{ color: "green.600" }}
                  >
                    <Box mr=".5rem">
                      <FaEdit />
                    </Box>
                  </Flex>
                </Tooltip>
              )}
              {tableObject?.action?.delete &&
                accountDetails?.level === "admin" &&
                name === "Pending Approval" && (
                  <Tooltip label="Delete" hasArrow arrowSize={15}>
                    <Flex
                      alignItems="center"
                      cursor="pointer"
                      color="red.500"
                      _hover={{ color: "red.600" }}
                    >
                      <Box
                        mr=".5rem"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!deleteLoading)
                            setOpenDeleteModal({
                              ...openDeleteModal,
                              data: item,
                              open: true,
                            });
                        }}
                      >
                        <IconButton aria-label="delete" size="sm">
                          <RiDeleteBin5Line color="red" />
                        </IconButton>
                      </Box>
                    </Flex>
                  </Tooltip>
                )}
            </Flex>
          </Td>
        )}
        {workFlowData?.fileViewer?.showApprHistory && (
          <Td
            onClick={(e: any) => {
              e.stopPropagation();
              if (workFlowData?.fileViewer?.show) {
                let appr =
                  getApprovalStatus(item.approval) === "rejected"
                    ? "approvalHistory"
                    : "fileModal";
                handleOpenModal({
                  file: item?.file?.[0],
                  value: item.values,
                  id: item?._id,
                  level: accountDetails.level,
                  approvalData: item?.approval,
                  documentId: item?.documentId,
                  tagType: item?.tags?.extraction?.type,
                  item: item,
                  type: "pdfApproval",
                  modalType: appr,
                });
              }
            }}
          >
            <Center>
              <Flex gap={3}>
                <Tooltip label="View Approval History" hasArrow arrowSize={15}>
                  <Flex
                    alignItems="center"
                    cursor="pointer"
                    color="red.500"
                    _hover={{ color: "red.600" }}
                  >
                    <Box w="30px">
                      <FaHistory />
                    </Box>
                  </Flex>
                </Tooltip>
                {accountDetails &&
                  accountDetails?.level === "level-1" &&
                  accountDetails?.role === "uploader" &&
                  checkLastRecord(item.approval) === "isReupload" ? (
                  <Tooltip label="Re-Upload Document" hasArrow arrowSize={5}>
                    <Button
                      bg="teal.300"
                      size="xs"
                      color="white"
                      _hover={{ bg: "teal.400" }}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        handleOpenUploadModal("alternative", item?._id);
                      }}
                    >
                      <FaFileUpload />
                    </Button>
                  </Tooltip>
                ) : (
                  <Box w="28px"></Box>
                )}
              </Flex>
            </Center>
          </Td>
        )}
        {canShowDocuments(workFlowData, accountDetails) && workflowProcess.processName !== "foreign" ? (
          <Td>
            <Tooltip label="Add additional documents" hasArrow placement="left">
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedRows([item]);
                  setAddtionalDocuments({
                    open: true,
                    data: item.addtionalDocuments || [],
                  });
                }}
                textAlign="center"
              >
                <HiOutlineDocumentAdd size={18} color="#4CAF50" />
              </Box>
            </Tooltip>
          </Td>
        ) : null}
      </React.Fragment>
    );
  };

  const handleDropdownChange = (value: any, label: string) => {
    setSelectedOptions((prev: any) => ({ ...prev, [label]: value }));
  };

  const handleSearchChange = (value: string) => {
    setSearch(value);
  };

  const handleApply = () => {
    handleGet();
  };

  const resetFilters = () => {
    setSearchFilters([]);
    setSelectedOptions({});
    setSearch("");
    setSortDirection({});
    resetDates(); // This resets global dates
    handleGet(undefined, undefined, true);
  };

  const handleCloseApprovalModal = () => {
    setSelectedRows([]);
    setIsOpen({ isOpen: false, data: null, type: "isFile" });
  };

  const handleOpenWordModal = () => {
    setIsOpen({ isOpen: true, data: null, type: "word" });
    setWordType("create");
  };

  function checkLastRecord(history: any) {
    if (history.length === 0) return "notUpload";
    const lastRecord = history[history.length - 1];
    const isReupload =
      lastRecord.level === "level-1" && lastRecord.status === "approved";
    return isReupload ? "isReupload" : "notUpload";
  }

  const removeDocumentIdFromParams = () => {
    try {
      setSearchParams((prev) => {
        const params = new URLSearchParams(prev);
        params.delete("documentId");
        return params;
      });
      setActivePage(routePath.Dashboard);
    } catch (err: any) {
      console.error("Failed to remove documentId", err);
    }
  };

  return Object.keys(tableObject).length === 0 ? (
    <Box>
      <Text textAlign="center" color="red" mt={5}>
        {" "}
        No table are selected{" "}
      </Text>
    </Box>
  ) : (
    <Box
      boxShadow="rgb(0 0 0 / 20%) 0px 0px 11px"
      bg="white"
      p={{ base: "1rem", md: "1.125rem 1.375rem" }}
      rounded={8}
    >
      <Grid
        templateColumns={"1fr auto"}
        alignItems="center"
        justifyContent="space-between"
        gap="0.5rem"
      >
        <Box>
          {tableObject?.header?.label && tableObject?.header?.isActive && (
            <Flex display="flex" columnGap={4}>
              <IconButton
                aria-label="Back"
                icon={<FaBackward />}
                variant="ghost"
                fontSize="22px"
                onClick={() => removeDocumentIdFromParams()}
                _hover={{ bg: "teal.50" }}
              />
              <Heading
                fontSize={{
                  base: "1.115rem",
                  lg: "1.6rem",
                }}
                color="teal.300"
                display={{ base: "none", md: "block" }}
              >
                {" "}
                {accountDetails?.level === "level-1" &&
                  accountDetails?.role === "uploader"
                  ? null
                  : tableObject?.header?.label}
              </Heading>
            </Flex>
          )}
          {accountDetails &&
            accountDetails?.level === "level-1" &&
            accountDetails?.role === "uploader" &&
            type === "pending" && (
              <Button
                bg="teal.300"
                color="white"
                _hover={{ bg: "teal.400" }}
                onClick={() => handleOpenUploadModal("upload")}
              >
                {isBreakpoint ? <FaFileUpload /> : "Upload Document"}
              </Button>
            )}
        </Box>
        <Flex gap="0.5rem" alignItems="center" justifyContent="end">
          <Box
            display={{ base: "none", lg: "flex" }}
            gap="0.5rem"
            justifyContent="space-between"
          >
            {tableObject?.searchActive && (
              <SearchBox
                onSearch={() => { }}
                setValue={setSearch}
                value={search}
              />
            )}
            {tableObject?.dateActive &&
              (workFlowData?.dateFilter?.rangePicker ? (
                <CustomDateRangePicker
                  onStartDateChange={setStartDate}
                  onEndDateChange={setEndDate}
                  dateFrom={startDate}
                  dateTo={endDate}
                  months={2}
                />
              ) : (
                <>
                  <Flex>
                    <Datepicker
                      label="From"
                      date={startDate}
                      onDateChange={setStartDate}
                    />
                  </Flex>
                  <Flex flexDirection={"row"}>
                    <Datepicker
                      label="To"
                      date={endDate}
                      onDateChange={setEndDate}
                    />
                  </Flex>
                </>
              ))}
          </Box>
          <DownloadExcelComponent type={type} />
          {tableObject?.dateActive && (
            <Box display={{ base: "none", lg: "block" }}>
              <Tooltip hasArrow textAlign={"center"} label="Search">
                <Button
                  bg="teal.300"
                  color="white"
                  w={{ base: "auto", lg: "3rem" }}
                  _hover={{ bg: "teal.400" }}
                  onClick={() => handleGet()}
                >
                  <SearchIcon />
                </Button>
              </Tooltip>
            </Box>
          )}
          <Box>
            <Tooltip hasArrow textAlign={"center"} label="Reset">
              <Button
                border="2px solid"
                borderColor="teal.300"
                bg="white"
                color="teal.400"
                _hover={{ bg: "teal.300", color: "white" }}
                onClick={resetFilters}
              >
                <HiOutlineRefresh fontSize="1.2rem" />
              </Button>
            </Tooltip>
          </Box>
          {tableObject?.filterActive && (
            <>
              <Box
                display={{ base: "none", md: "block" }}
                w={{ base: "auto", lg: "3rem" }}
              >
                <MultiDropdown
                  selectedOptions={selectedOptions}
                  onDropdownChange={handleDropdownChange}
                  dropdowns={transformedOptions}
                  onApply={handleApply}
                  searchValue={search}
                  onSearchChange={handleSearchChange}
                  resetFilters={resetFilters}
                  dateFrom={startDate}
                  dateTo={endDate}
                  setFromDate={setStartDate}
                  setToDate={setEndDate}
                  isTable={true}
                  handleGet={handleGet}
                  tableObject={tableObject}
                />
              </Box>
              <Box
                position="fixed"
                top="15rem"
                right="1rem"
                display={{ base: "block", md: "none" }}
                w="3rem"
                zIndex={10}
              >
                <MultiDropdown
                  selectedOptions={selectedOptions}
                  onDropdownChange={handleDropdownChange}
                  dropdowns={transformedOptions}
                  onApply={handleApply}
                  searchValue={search}
                  onSearchChange={handleSearchChange}
                  resetFilters={resetFilters}
                  dateFrom={startDate}
                  dateTo={endDate}
                  setFromDate={setStartDate}
                  setToDate={setEndDate}
                  isTable={true}
                  handleGet={handleGet}
                  tableObject={tableObject}
                />
              </Box>
            </>
          )}
          {accountDetails &&
            accountDetails?.level === "level-1" &&
            workFlowData &&
            workFlowData?.fileViewer?.approvalModalOption === "isWord" &&
            type === "pending" && (
              <Button
                bg="teal.300"
                color="white"
                _hover={{ bg: "teal.400" }}
                onClick={handleOpenWordModal}
              >
                <Box display={{ base: "none", md: "block" }}>
                  <Text>Add Word</Text>
                </Box>
                <Box display={{ base: "block", md: "none" }}>
                  <FaPlus />
                </Box>
              </Button>
            )}
          {activePage === "Pending Approval" &&
            accountDetails.role === "approver" &&
            (workFlowData?.bulkApproveApproval ||
              workFlowData?.bulkRejectApproval) && (
              <Flex gap="0.5rem" justifyContent="end">
                {activePage === "Pending Approval" &&
                  accountDetails.role === "approver" &&
                  workFlowData?.bulkApproveApproval && (
                    <Button
                      fontSize="sm"
                      bg="green.400"
                      color="white"
                      _hover={{ bg: "green.500" }}
                      isDisabled={
                        selectedRows.length ? false : true || submitLoader
                      }
                      onClick={() =>
                        setCommentModel({
                          open: true,
                          selectedStatus: "approved",
                          comment: "",
                          isMulti: true,
                        })
                      }
                    >
                      Approve
                    </Button>
                  )}
                {activePage === "Pending Approval" &&
                  accountDetails.role === "approver" &&
                  workFlowData?.bulkRejectApproval && (
                    <Button
                      fontSize="sm"
                      isDisabled={
                        selectedRows.length ? false : true || submitLoader
                      }
                      colorScheme="red"
                      onClick={() =>
                        setCommentModel({
                          open: true,
                          selectedStatus: "rejected",
                          comment: "",
                          isMulti: true,
                        })
                      }
                    >
                      Reject
                    </Button>
                  )}
              </Flex>
            )}
        </Flex>
      </Grid>

      <Box
        position="relative"
        overflow="auto hidden"
        className="customScrollBar"
      >
        <Table
          variant={activePage === "Pending Approval" ? "simple" : "striped"}
          mt="1rem"
        >
          <Thead>
            <Tr>
              {activePage === "Pending Approval" &&
                (workFlowData?.bulkApproveApproval ||
                  workFlowData?.bulkRejectApproval) &&
                accountDetails.role === "approver" && (
                  <Th w={10}>
                    <Checkbox
                      colorScheme="teal"
                      isChecked={data.length === selectedRows.length}
                      isIndeterminate={
                        selectedRows.length > 0 &&
                        data.length !== selectedRows.length
                      }
                      onChange={(e: any) => {
                        if (e.target.checked) {
                          setSelectedRows(data);
                        } else {
                          setSelectedRows([]);
                        }
                      }}
                    />
                  </Th>
                )}
              {generateHeaders()}
              {activePage === "Pending Approval" &&
                accountDetails?.level === "level-1" && workflowProcess?.processName !== "foreign" && <Th>Assign Doc</Th>}
              {workFlowData?.withdrawalApproval?.includes(
                name?.toLowerCase()
              ) &&
                workFlowData.withdrawalLevel.includes(accountDetails.level) && (
                  <Th>Withdrawal Doc</Th>
                )}
              {((tableObject.action.downloadPDF &&
                accountDetails?.userPermission?.includes("download")) ||
                (tableObject.action.downloadExcel &&
                  accountDetails?.userPermission?.includes("download")) ||
                accountDetails?.userPermission?.includes("mail")) &&
                name === "Approved" && <Th></Th>}
            </Tr>
          </Thead>
          <Tbody>
            <TableLoader
              loader={loading}
              show={data.length}
              columns={
                actionButton && workFlowData?.fileViewer?.showApprHistory
                  ? tableObject?.columnName?.length + 2
                  : actionButton
                    ? tableObject?.columnName?.length + 1
                    : workFlowData?.fileViewer?.showApprHistory
                      ? tableObject?.columnName?.length + 1
                      : tableObject?.columnName?.length
              }
            >
              {sortedData.map((item: any, index) => (
                <React.Fragment key={index}>
                  <Tr
                    fontSize="sm"
                    onClick={(e: any) => {
                      if (workFlowData?.fileViewer?.show) {
                        let appr =
                          getApprovalStatus(item.approval) === "rejected"
                            ? "approvalHistory"
                            : "fileModal";
                        handleOpenModal({
                          file: item?.file?.[0],
                          value: item.values,
                          id: item?._id,
                          level: accountDetails.level,
                          approvalData: item?.approval,
                          documentId: item?.documentId,
                          tagType: item?.tags?.extraction?.type,
                          item: item,
                          type:
                            workFlowData?.fileViewer?.approvalModalOption ===
                              "isFile"
                              ? "file"
                              : workFlowData?.fileViewer
                                ?.approvalModalOption === "isTable"
                                ? "table"
                                : workFlowData?.fileViewer
                                  ?.approvalModalOption === "isCurebay"
                                  ? "curebay"
                                  : workFlowData?.fileViewer
                                    ?.approvalModalOption === "schema"
                                    ? "schema"
                                    : workFlowData?.fileViewer
                                      ?.approvalModalOption === "pdfApproval"
                                      ? "pdfApproval"
                                      : workFlowData?.fileViewer
                                        ?.approvalModalOption === "mdm"
                                        ? "mdm"
                                        : workFlowData?.fileViewer
                                          ?.approvalModalOption === "fields"
                                          ? "fields"
                                          : "word",
                          modalType: appr,
                        });
                      }
                    }}
                    cursor="pointer"
                    key={index}
                    bg={
                      activePage === "Pending Approval"
                        ? getStatus(item.approval) === "rejected"
                          ? "red.100"
                          : getStatus(item.approval) === "approved"
                            ? "green.100"
                            : undefined
                        : undefined
                    }
                  >
                    {activePage === "Pending Approval" &&
                      (workFlowData?.bulkApproveApproval ||
                        workFlowData?.bulkRejectApproval) &&
                      accountDetails.role === "approver" && (
                        <Td onClick={(e: any) => e.stopPropagation()}>
                          <Flex alignItems="center">
                            <Checkbox
                              variant="outline"
                              borderColor="teal"
                              colorScheme="teal"
                              isChecked={selectedRows.some(
                                (it: any) => it._id === item._id
                              )}
                              onMouseDown={(e: any) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                              onChange={(e: any) => {
                                handleSelectedBoxChange(item);
                              }}
                            />
                          </Flex>
                        </Td>
                      )}
                    {generateRows(item)}
                    {activePage === "Pending Approval" &&
                      accountDetails?.level === "level-1" && workflowProcess?.processName !== "foreign" && (
                        <Td>
                          <Flex gap={3}>
                            <Tooltip label="Assign Doc" hasArrow arrowSize={15}>
                              <Flex
                                alignItems="center"
                                cursor="pointer"
                                color="red.500"
                                _hover={{ color: "red.600" }}
                              >
                                <Box
                                  w="30px"
                                  onClick={(e: any) => {
                                    e.stopPropagation();
                                    setAssignDocument({
                                      open: true,
                                      data: item,
                                    });
                                  }}
                                >
                                  <MdAssignmentInd />
                                </Box>
                              </Flex>
                            </Tooltip>
                          </Flex>
                        </Td>
                      )}
                    {workFlowData?.withdrawalApproval?.includes(
                      name?.toLowerCase()
                    ) &&
                      workFlowData.withdrawalLevel.includes(
                        accountDetails.level
                      ) && (
                        <Td
                          onClick={(e: any) => {
                            e.stopPropagation();
                            setWithdrawalDoc({
                              open: true,
                              data: item,
                            });
                          }}
                        >
                          Withdrawal Doc
                        </Td>
                      )}
                    {((tableObject.action.downloadPDF &&
                      accountDetails?.userPermission?.includes("download")) ||
                      (tableObject.action.downloadExcel &&
                        accountDetails?.userPermission?.includes("download")) ||
                      accountDetails?.userPermission?.includes("mail")) &&
                      name === "Approved" && (
                        <Td>
                          <Flex alignItems="center" gap={2}>
                            {tableObject.action.downloadPDF &&
                              accountDetails?.userPermission?.includes(
                                "download"
                              ) && (
                                <Tooltip label="Download PDF" hasArrow>
                                  <Button
                                    size="xs"
                                    color="white"
                                    bg="red.400"
                                    _hover={{ bg: "red.500" }}
                                    onClick={(e: any) => {
                                      e.stopPropagation();
                                      if (item?.file?.length) {
                                        downloadPDF(item?.file?.[0]);
                                      } else {
                                        toastNotify({
                                          title: "No file",
                                          message: "Something went wrong",
                                          type: "error",
                                        });
                                      }
                                    }}
                                  >
                                    <Text>
                                      <FaFilePdf />
                                    </Text>
                                  </Button>
                                </Tooltip>
                              )}
                            {tableObject.action.downloadExcel &&
                              accountDetails?.userPermission?.includes(
                                "download"
                              ) &&
                              name === "Approved" && (
                                <Tooltip label="Download Excel" hasArrow>
                                  <Button
                                    size="xs"
                                    color="white"
                                    bg="green.500"
                                    _hover={{ bg: "green.600" }}
                                    onClick={(e: any) => {
                                      e.stopPropagation();
                                      if (
                                        Array.isArray(item?.values) &&
                                        item?.values?.length
                                      ) {
                                        downloadExcel(item?.values, "download");
                                      } else if (
                                        !Array.isArray(item?.values) &&
                                        item?.values?.values
                                      ) {
                                        downloadExcel(item?.values, "download");
                                      } else
                                        toastNotify({
                                          title: "No Data Found",
                                          message: "Something went wrong",
                                          type: "error",
                                        });
                                    }}
                                  >
                                    <Text>
                                      <FaFileExcel />
                                    </Text>
                                  </Button>
                                </Tooltip>
                              )}
                            {accountDetails?.userPermission?.includes("mail") &&
                              name === "Approved" && (
                                <Tooltip
                                  label="Send mail with attachment"
                                  hasArrow
                                >
                                  <Button
                                    size="xs"
                                    color="white"
                                    bg="green.500"
                                    _hover={{ bg: "green.600" }}
                                    onClick={(e: any) => {
                                      e.stopPropagation();
                                      if (
                                        Array.isArray(item?.values) &&
                                        item?.values?.length
                                      ) {
                                        handleOpenMail(item?.values);
                                      } else if (
                                        !Array.isArray(item?.values) &&
                                        item?.values?.values
                                      ) {
                                        handleOpenMail(item?.values);
                                      } else
                                        toastNotify({
                                          title: "No Data Found",
                                          message: "Something went wrong",
                                          type: "error",
                                        });
                                    }}
                                  >
                                    <Text>
                                      <MdEmail />
                                    </Text>
                                  </Button>
                                </Tooltip>
                              )}
                          </Flex>
                        </Td>
                      )}
                  </Tr>
                </React.Fragment>
              ))}
            </TableLoader>
          </Tbody>
        </Table>
      </Box>

      {isOpen.isOpen && isOpen.type === "file" && (
        <ViewerModal
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
        />
      )}
      {isOpen.isOpen && isOpen.type === "curebay" && (
        <CurbayViewerModel
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
        />
      )}
      {tableObject?.isPaginate?.isActive && (
        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
        />
      )}
      {commentModel.isMulti === true && (
        <AddComentModal
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          view={false}
          handleCloseModal={handleCloseModal}
          editedValues={{}}
          isMulti={true}
        />
      )}
      {openTableModel.open && openTableModel.file && (
        <FileViewerModal
          isOpen={openTableModel.open}
          onClose={() => {
            setOpenTableModel({ open: false, type: "file", file: null });
          }}
          viewerWidth="70vw"
          file={
            Array.isArray(openTableModel.file)
              ? openTableModel.file.length > 0
                ? openTableModel.file[0]
                : null
              : openTableModel.file
          }
        />
      )}
      {addtionalDocuments.open && (
        <AddtionalDocumentModal
          handleGet={handleGet}
          selectedRows={selectedRows}
          isOpen={addtionalDocuments.open}
          onClose={() => {
            setSelectedRows([]);
            setAddtionalDocuments({ data: [], open: false });
          }}
        />
      )}
      {isOpen.isOpen && isOpen.type === "word" && (
        <WordDocumentViewer
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          type={wordType}
          statusType={type}
        />
      )}
      {isOpen.isOpen && isOpen.type === "table" && (
        <TableViewerModel
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          tableObject={tableObject}
        />
      )}
      {isOpen.isOpen && isOpen.type === "pdfApproval" && (
        <ApprovalHistoryModal
          isOpen={isOpen.isOpen}
          onClose={handleCloseApprovalModal}
          name={name}
          approvalHistory={approvalData}
          file={selectedFile}
          id={selectedId}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          handleGet={handleGet}
          docID={documentID}
        />
      )}
      {openFilesModal.open === true &&
        openFilesModal.data &&
        openFilesModal.type === "files_verification" && (
          <FilesModal
            isDisabled={isDisabled}
            commentData={comment}
            tagType={tagType}
            documentType={documentType}
            name={name}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            commentModel={commentModel}
            setCommentModel={setCommentModel}
            file={selectedFile}
            docID={documentID}
            values={values}
            open={openFilesModal.open}
            data={openFilesModal.data}
            getData={handleGet}
            close={() => {
              setOpenFilesModel({
                open: false,
                data: null,
                type: "files_verification",
              });
            }}
          />
        )}
      <UploadDocumentModal
        isOpen={isUploadOpen.open}
        onClose={handleCloseUploadModal}
        type={modalType}
        handleGet={handleGet}
        id={isUploadOpen.id}
      />
      {isOpen.isOpen && isOpen.type === "mdm" && (
        <CurbayMedicineCustomModal
          handleGet={handleGet}
          open={isOpen.isOpen}
          close={() => {
            setSelectedRows([]);
            setIsOpen({ isOpen: false, type: "mdm", data: null });
          }}
          getData={handleGet}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          file={selectedFile}
          docID={documentID}
          values={values}
        />
      )}
      {isOpen.isOpen && isOpen.type === "fields" && (
        <FieldsModal
          handleGet={handleGet}
          open={isOpen.isOpen}
          close={() => {
            setSelectedRows([]);
            setIsOpen({ isOpen: false, type: "fields", data: null });
          }}
          getData={handleGet}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          file={selectedFile}
          docID={documentID}
          values={values}
        />
      )}
      <MailModal
        fileData={fileData}
        isOpen={isMailOpen.open}
        onClose={handleCloseMail}
        fieldName={fieldName}
        setFieldName={setFieldName}
        transformedData={exportToExcelsss(transformedData)}
        values={isMailOpen.data}
        setFileData={setFileData}
        sendMail={["mail"]}
        setFinalResults={setFinalResults}
      />
      {openSchemaModel.open && openSchemaModel.type === "schema" && (
        <DynamicSchemaModel
          openSchemaModal={openSchemaModel}
          isOpen={openSchemaModel.open}
          data={openSchemaModel.data}
          file={selectedFile}
          onClose={() => {
            setOpenSchemaModel({
              open: false,
              data: null,
              type: "schema",
              initialUpload: false,
              file: null,
            });
            setSelectedRows([]);
          }}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          name={name}
        />
      )}
      <WithDrawalDocModal
        title={`Document : ${withdrawalDoc?.data?.documentId}`}
        bodyText="This action cannot be undone"
        subTitleText="Please Confirm?"
        onConfirm={() => withDrawalDocuments()}
        isOpen={withdrawalDoc.open}
        onClose={() =>
          setWithdrawalDoc({ data: null, open: false, loading: false })
        }
        loading={withdrawalDoc?.loading}
      />
      <DeleteModal
        title={`Document : ${openDeleteModal?.data?.documentId}`}
        bodyText="This action cannot be undone. Deleting this user will remove all associated permissions."
        subTitleText="Please Confirm?"
        onConfirm={() => deleteDocuments()}
        isOpen={openDeleteModal.open}
        onClose={() => setOpenDeleteModal({ data: null, open: false })}
        loading={deleteLoading}
      />
      <AssignDocumentModal
        isPending={true}
        isOpen={assignDocument.open}
        data={assignDocument?.data}
        close={() => setAssignDocument({ open: false, data: null })}
        getAllData={handleGet}
      />
    </Box>
  );
}